





























































import { Component, Vue } from 'vue-property-decorator'

@Component

export default class ComponentModalSolicitacaoCirurgiaMedicoDataAgendamento extends Vue {
  messages: any[] = []
  message: String = ''

  get getShow() {
    return false
  }

  async inputFile(newFile, oldFile) {
    const form = new FormData()
    form.append('laudos', newFile.file)

    const header: any = {
      'Content-Type': 'multipart/form-data',
    }
  }
}

